import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private loaderSubj: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isLoading$: Observable<boolean> = this.loaderSubj as Observable<boolean>;
  requestAmount = 0;
  lastShowTime: number;

  show(log?): void {
    if (!this.requestAmount) {
      this.loaderSubj.next(true);
    }
    this.lastShowTime = new Date().getTime();
    this.requestAmount++;
    // console.log('SHOW', this.requestAmount, log);
  }

  hide(log?): void {
    this.requestAmount--;
    // console.log('HIDE', this.requestAmount, log);
    if (this.requestAmount < 0) {
      console.error('[LoaderService] You are calling .hide() more often than .show()');
    }
    if (this.requestAmount <= 0) {
      const MIN_LOADER_SHOW_TIME_MS = 1000;
      const diff = new Date().getTime() - this.lastShowTime;
      if (diff >= MIN_LOADER_SHOW_TIME_MS) {
        this.loaderSubj.next(false);
        return;
      }
      const delay = MIN_LOADER_SHOW_TIME_MS - diff;
      setTimeout(() => {
        this.loaderSubj.next(false);
      }, delay);
    }
  }
}
